module.exports = __webpack_public_path__ + "media/svg/dropdown-arrow-b09fed91.svg";